import React from 'react';
import { Typography, Box, Card, CardContent, Grid,} from '@mui/material';
import theme from '../../components/LayoutComponents/theme';
import BuildProfile from '../../assets/images/BuildProfile.png'
import KeepGrowing from '../../assets/images/KeepGrowing.png'
import ExploreOpportunities from '../../assets/images/ExploreOpportunities.png'
import TipCard from './TipCard';

function MemberLandingPage({ handlePageClick, isMobile }) {
  const style = {
    cardStyle:{
    backgroundColor: '#f0f0f0',
    cursor: 'pointer',
    height: '100%',
    borderRadius: 6,
    transition: 'transform 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease, border 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 12px rgba(110, 51, 106, 0.1)',
      border: '1px solid rgba(110, 51, 106, 0.2)',
    },
  },
  cardTitle:{
     color: theme.colors.purple, mb: 1
  }
}
  return (
    <Box
      sx={{
        padding: isMobile ? 2 : 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        justifyContent: 'center',
      }}
    >
      {/* Welcome Section */}
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        sx={{
          color: theme.colors.yellow,
          fontWeight: theme.typography.fontWeightBold,
          textAlign: 'center',
          mb: 1,
        }}
      >
        Welcome to Your Career Hub
      </Typography>
      <Typography
        variant={isMobile ? 'body1' : 'h6'}
        sx={{
          color: 'black',
          textAlign: 'left',
          mb: 3,
        }}
      >
        We’re glad you’re here! The National Talent Hub™ helps you explore career paths, strengthen your skills, and connect directly with employers in semiconductor, advanced manufacturing, and technology fields.
      </Typography>

      <Typography
        variant={isMobile ? 'body1' : 'h6'}
        sx={{
          color: 'black',
          textAlign: 'left',
          mb: 4,
        }}
      >
        Here’s how to get started:
      </Typography>

      {/* Steps Cards */}
      <Grid
        container
        spacing={3}
        justifyContent="center" // centers the cards
      >
        {/* Build Your Profile */}
        <Grid item xs={12} md={4}>
          <Card
            sx={style.cardStyle}
            onClick={() => handlePageClick('Build Your Profile')}
          >
            <CardContent>
              <img src={BuildProfile} alt="Build Your Profile" style={{ width: '60px', height: '60px', marginBottom: '10px' }} />
              <br/>
              <Typography
                variant='title1'
                fontWeight={theme.typography.fontWeightBold}
                sx={style.cardTitle}
              >
                1. Build Your Profile
              </Typography>
              <Typography variant="body2">
                Upload your résumé or manually add your skills. The system analyzes how your strengths align with high-demand technician roles. You’ll get a personalized Skill Match Score to guide your next steps.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Explore Opportunities */}
        <Grid item xs={12} md={4}>
          <Card
            sx={style.cardStyle}
            onClick={() => handlePageClick('Explore Opportunities')}
          >
            <CardContent>
              <img src={ExploreOpportunities} alt="Explore Opportunities" style={{ width: '60px', height: '60px', marginBottom: '10px' }} />
              <br/>
              <Typography
                 variant='title1'
                fontWeight={theme.typography.fontWeightBold}
                sx={style.cardTitle}
              >
                2. Explore Opportunities
              </Typography>
              <Typography variant="body2">
                Discover open jobs and Registered Apprenticeships that fit your background. Apply directly to employers and save positions to track your progress.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Keep Growing */}
        <Grid item xs={12} md={4}>
          <Card
           sx={style.cardStyle}
            onClick={() => handlePageClick('Profile')}
          >
            <CardContent>
              <img src={KeepGrowing} alt="Keep Growing" style={{ width: '60px', height: '60px', marginBottom: '10px' }} />
              <br/>
              <Typography
                 variant='title1'
                fontWeight={theme.typography.fontWeightBold}
                sx={style.cardTitle}
              >
                3. Keep Growing
              </Typography>
              <Typography variant="body2">
                Continue building your skills and experience. Update your profile anytime as you learn something new or complete training.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', flexDirection:'row'}}>
      <TipCard
        isMobile={isMobile}
        onClose={() => {}}
      />
      </Box>
    </Box>
  );
}

export default MemberLandingPage;
